import {Exclude, Expose} from 'class-transformer';

@Exclude()
export class UserLoginResponseModel {
  @Expose()
  public token: string;

  @Expose()
  public refresh_token: string;
}
